// Shared MUI `sx` styling for the "section" Paper cards used in the
// device-config Fields view (Client Radio, Tree blocks, Port
// Forwarding). The default `Paper variant="outlined"` border is
// intentionally faint, which made the cards almost invisible against
// the dialog body. Bumping the border a couple of shades darker and
// adding a subtle drop shadow makes each section read as a discrete
// card in both light and dark themes.

export const fieldSectionSx = {
  p: 2,
  mb: 2,
  borderWidth: 1,
  borderColor: (theme) => (theme.palette.mode === 'dark'
    ? theme.palette.grey[700]
    : theme.palette.grey[400]),
  boxShadow: (theme) => (theme.palette.mode === 'dark'
    ? '0 1px 2px rgba(0,0,0,0.4)'
    : '0 1px 2px rgba(0,0,0,0.08)'),
};
